import foto1 from './Recursos/Testimonios/foto1.png'
import foto2 from './Recursos/Testimonios/foto2.png'
import foto3 from './Recursos/Testimonios/foto3.png'
import foto4 from './Recursos/Testimonios/foto4.png'
import foto5 from './Recursos/Testimonios/foto5.png'


export const NUMWASS = '529516524208'

export const SECCIONES = ['Catalogo', 'Testimonios', 'Contactos', 'Nosotros']

export const TESTIMONIOS =
    [
        {
            "nombre": "Ximena Hernández",
            "profesion": "Arquitecta",
            "testimonio": "El proceso de compra fue sumamente fluido y el envío llegó antes de lo esperado a la Ciudad de México. Respecto al sabor, este mezal espadín tiene unas notas ahumadas muy equilibradas que no opacan el gusto herbal del agave. Se percibe un retrogusto persistente a tierra mojada y cítricos que lo hace ideal para tomarlo derecho con su respectiva naranja y sal de gusano.",
            "img": foto3
        },
        {
            "nombre": "Gerardo Ruiz",
            "profesion": "Chef",
            "testimonio": "Como profesional de la cocina, busco perfiles de sabor complejos y este ensamble de magueyes silvestres superó mis expectativas. La experiencia en la tienda en línea fue muy profesional, con descripciones detalladas de la región de origen en Oaxaca. Al catarlo, destacan notas de pimienta gorda y un dulzor mineral muy sutil que limpia el paladar de forma elegante.",
            "img": foto1
        },
        {
            "nombre": "Sofía Villalobos",
            "profesion": "Diseñadora",
            "testimonio": "Me encantó el diseño de la botella, pero el contenido es lo que realmente vale la pena. La atención al cliente por WhatsApp resolvió todas mis dudas sobre el tiempo de maduración del agave. El sabor es robusto pero sedoso, con una presencia de humo de leña de encino que se siente muy tradicional y auténtica. Es perfecto para compartir en cenas especiales.",
            "img": foto3
        },
        {
            "nombre": "Alejandro Meza",
            "profesion": "Consultor",
            "testimonio": "Es la tercera vez que compro esta marca y la consistencia es impecable. El empaque de protección para el envío es de los mejores que he visto, garantizando que el producto llegue intacto. En boca es una explosión de sabores; primero llega el calor del alcohol bien integrado y luego se transforma en sabores frutales de plátano asado y piña ahumada. Una joya artesanal.",
            "img": foto4
        },
        {
            "nombre": "Beatriz Alcántara",
            "profesion": "Abogada",
            "testimonio": "Buscaba un regalo corporativo y la asesoría que recibí para elegir el mezcal adecuado fue excelente. Terminamos eligiendo un tobalá que tiene un perfil de sabor mucho más delicado y floral. Los clientes quedaron fascinados con el balance entre la fuerza del agave y las notas de flores blancas y miel que se sienten en el primer trago. La entrega en Monterrey fue impecable.",
            "img": foto5
        }
    ]

export const CONTACTOS = [
    {
        nombre: 'Dirección',
        descripcion: 'Calle Libertad número 4, San Pablo Huixtepec, Zimatlán, Oaxaca',
        url: 'https://www.google.com/maps/dir/?api=1&destination=16.825246033784897,-96.78016551184332,190&dir_action=navigate'
    },
    {
        nombre: 'Telefonos',
        descripcion: '52 951 652 4208',
        url: 'https://api.whatsapp.com/send?phone=529516524208&text=Hola%2C%20quiero%20saber%20mas%20de%20Generacion%20Mezcal'
    },
    {
        nombre:'correo',
        descripcion: 'info@generacionmezcal.com',
        url: 'mailto:info@generacionmezcal.com'

    }
]
